import styled from "styled-components";

export const ContainerCertificado = styled.div`
  flex: 1;
  display: flex;
  background-color: #ccd3d9;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  a {
    text-decoration: none;
    cursor: pointer;
    i {
      font-size: 25px;
    }
  }

  .areaButton {
    width: 877px;
    display: flex;
    margin-top: 10px;
    align-items: center;
    justify-content: space-between;

    @media only screen and (max-width: 900px) {
      width: 700px;
    }

    @media only screen and (max-width: 700px) {
      margin-top: -135px;
      width: 440px;
    }

    @media only screen and (max-width: 450px) {
      margin-top: -200px;
      width: 261px;
    }
  }
`;

export const Button = styled.button`
  background-color: #1566a0;
  color: #fff;
  cursor: pointer;
  transition: 0.3s;
  font-size: 12px;
  border-radius: 4px;
`;

export const Certificado = styled.div`
  width: 877px;
  height: 620px;
  background-color: #fff;

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    height: 100%;

    .certificado-topo {
      height: 15%;
    }
    .certificado-content {
      height: 70%;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .containerAssignatures {
        display: flex;
        width: "100%";
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
      }
    }
    .certificado-footer {
      height: 15%;
    }
  }

  .certificado-verso {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 10px 40px;

    .url {
      font-size: 10px;
      text-align: right;
    }
  }

  @media only screen and (max-width: 900px) {
    transform: scale(0.8);
    width: 877px;
  }

  @media only screen and (max-width: 700px) {
    transform: scale(0.5);
    margin-top: -200px;
  }

  @media only screen and (max-width: 450px) {
    transform: scale(0.3);
  }
`;
